import { logWrapper } from '../../utils';

export default {
  removePermantlyModalController: [
    'runtimeConstant',
    '$scope',
    'revisionListService',
    function (runtimeConstant, $scope, revisionListService) {
      'use strict';

      function parent_cancelButton() {
        $scope.modalRemoveDocument.close();
      }

      function deleteModel() {
        return new Promise((resolve) => {
          revisionListService
            .deletePermanently($scope.ids)
            .then(() => {
              for (var i = 0; i < $scope.docs.length; i++) {
                var rev = $scope.docs[i];
                rev.removed = true;
                rev.updatePermissions();
                $scope.loadDocuments();
                $scope.modalRemoveDocument.close();
                resolve();
              }
            })
            .catch(() => resolve());
        });
      }

      function run() {
        try {
          $scope.$parent.cancelButton = logWrapper(
            parent_cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteModel = logWrapper(
            deleteModel,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
